// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".advice[data-v-11af146d] {\n  font-size: 10px;\n}\n[dir] .vs-circle-slider vs-circles-slider vs-slider--circles vs-slider--circle[data-v-11af146d] {\n  background: darkorange;\n}\n", ""]);
// Exports
module.exports = exports;
